import $ from 'jquery'
import {LOOKUP_API_ENDPOINT} from '../constants'
import {getBusinessListItemsByCountry, getFormattedListOfBusinesses,} from '../helpers'
import {buildSearchNoResults, buildSearchResultListItems,} from './build-business-items'
import {setClickEventToBusinessItem} from './set-click-event-business-item'
import {setLoadingState} from './set-loading-state'
import {isAu} from '@/scripts/util/countryCheck'

/**
 * Fetch the ABN & NZBN business number and return list of business details and build the UI
 */
export function fetchBusinessNumber(query, elements, method) {
  const { ABNResultWrapper, hiddenBusinessNumberInputField } = elements
  const inputWrapper = hiddenBusinessNumberInputField.parentElement
  let listOfBusinessItems = ``
  let requestUrl = LOOKUP_API_ENDPOINT

  let ajaxOptions = {
    type: `POST`,
    beforeSend: function() {
      setLoadingState(inputWrapper)
    },
    success: function(response) {
      let businesses = getFormattedListOfBusinesses(response)
      if (typeof businesses === `object`) {
        businesses = Object.values(businesses)
      }

      if (businesses && businesses.length > 0) {
        ABNResultWrapper.classList.remove(`hide`)
        listOfBusinessItems = getBusinessListItemsByCountry(businesses)
        setTimeout(() => setClickEventToBusinessItem(elements), 1000)
      } else {
        ABNResultWrapper.classList.remove(`hide`)
        listOfBusinessItems = buildSearchNoResults()
      }
      setLoadingState(inputWrapper, false)
      buildSearchResultListItems(ABNResultWrapper, listOfBusinessItems)
    },
    error: function(response) {
      setLoadingState(inputWrapper, false)
    },
  }

  if (isAu()) {
    requestUrl += `/api/abn/`
    if (method === `name`) {
      requestUrl += `name/`
      ajaxOptions.data = {name: query}
    } else {
      requestUrl += `ABN/`
      ajaxOptions.data = {ABN: query}
    }
  } else {
    requestUrl += `/api/nzbn/`
    if (method === `name`) {
      ajaxOptions.data = {'search-term': query}
    } else {
      requestUrl += `${query}/`
    }
  }

  ajaxOptions.url = requestUrl

  $.ajax(ajaxOptions)
}
